export default "__VITE_ASSET__b2a74632__"